// @flow
import * as React from 'react';
import { Transition, animated } from 'react-spring';
import './CollectionItemTransitionProvider.scss';

type Props = {
  items: Array<*>,
  itemKey: (*) => string | number,
  children: (*) => React.Node,
};

export class CollectionItemTranisitionProvider extends React.PureComponent<
  Props
> {
  render() {
    const { items, itemKey, children } = this.props;

    return (
      <div className="Collection">
        <Transition
          native
          items={items}
          keys={itemKey}
          initial={{ opacity: 1, height: 'auto', scale: 1 }}
          leave={{ opacity: 0, height: 0, scale: 0 }}
        >
          {items.map((item, index) => ({ opacity, height, scale }) => (
            <animated.div
              style={{
                opacity,
                height,
                transformOrigin: '50% 0',
                transform: scale.interpolate(v => `scale(${v})`),
                // Ensure that the observation select menus are not clipped
                // using relative positioning and decrementing z-index
                // https://stackoverflow.com/questions/16687023/bug-with-transform-scale-and-overflow-hidden-in-chrome
                position: 'relative',
                zIndex: 10 + items.length - index,
              }}
              className="Collection__ItemWrapper"
            >
              <div className="Collection__Item">{children(item)}</div>
            </animated.div>
          ))}
        </Transition>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CollectionItemTransitionProvider.js